<div class="ir-area ir-mask th-mask" *ngIf="inspection">
  <div class="ir-modal th-modal">
    <div class="ir-modal--title">
      <div class="ir-line--right">
        <div class="ir-btn th-btn-modal" (click)="cancel()">
          <i class="material-icons">close</i>
        </div>
      </div>
      <div class="ir-line">
        <div class="ir-line-content">
          <span>{{ 'inspections.information-of' | translate }} &laquo; {{ inspection.name }} &raquo;</span>
        </div>
      </div>
    </div>
    <div class="ir-modal--body ir-pv8 ir-ph8" #scroll>
      <div class="ir-content--modal th-content">
        <div class="ir-mv2 ir-mh2 plugin-container" *ngFor="let p of inspection.plugins | orderBy : 'order'">
          <div class="sessions">
            <ng-container *ngFor="let session of p?.sessions">
              <i
                *ngIf="session.user"
                [title]="session.user"
                class="material-icons"
                [style.color]="session.color"
                [class.disabled]="session.away"
                [class.away]="session.away"
                [class.active]="!session.away"
                >account_circle</i
              >
            </ng-container>
          </div>
          <ir-plugin [plugin]="p" [inspection]="inspection" #plugin></ir-plugin>
        </div>
        <div class="ir-item-empty ir-mv8" *ngIf="inspection.plugins?.length == 0">
          <p>
            <span>{{ 'points.no-plugins' | translate }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
